export default "__VITE_ASSET__46ba1625__"